/**
 * FieldBox — read-only input-style display resembling a disabled form field.
 * Shared by IcsTransferDetailView and ProductionRecordDetailView so the two
 * VB6-style detail pages keep identical field styling.
 */
interface FieldBoxProps {
  value: string;
  className?: string;
  mono?: boolean;
}

const FieldBox = ({ value, className = '', mono = false }: FieldBoxProps) => (
  <span
    className={`
      inline-block px-2.5 py-1 min-h-[30px] leading-[18px]
      border border-gray-200 dark:border-gray-600
      bg-gray-50 dark:bg-gray-700/50
      rounded-md text-sm text-gray-900 dark:text-gray-100
      shadow-inner shadow-gray-100 dark:shadow-gray-900/30
      ${mono ? 'font-mono tracking-wide' : ''}
      ${className}
    `}
  >
    {value || ' '}
  </span>
);

export default FieldBox;
